import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { root, critical, caution } from "./Highlight.css.mjs";
const styleForTone = { caution, critical };
const Highlight = ({ children, tone }) => /* @__PURE__ */ jsx(Box, { component: "mark", className: [root, styleForTone[tone]], children });
export {
  Highlight
};
